import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  showPrice?: boolean;
  href?: string;
}
export function Button({
  children,
  className = '',
  showPrice = false,
  href,
  ...props
}: ButtonProps) {
  const handleClick = () => {
    if (href) {
      const el = document.querySelector(href);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`bg-bronze hover:bg-bronze-dark text-white font-medium py-4 px-8 rounded-none transition-colors duration-300 shadow-sm flex flex-col items-center justify-center gap-1 w-full sm:w-auto ${className}`} {...props} data-id="element-19">
      <span className="text-lg tracking-wide" data-id="element-20">{children}</span>
      {showPrice && <span className="text-sm text-white/80 font-normal tracking-wider" data-id="element-21">
          $9.00 USD
        </span>}
    </motion.button>;
}